import React from 'react';
import {
  Box,
  Container,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Heading,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import MoodTrendsChart from './components/MoodTrendsChart';
import LocationStats from './components/LocationStats';
import TagStats from './components/TagStats';
import DailyTrackingCalendar from './components/DailyTrackingCalendar';
import TrackingTrends from './components/TrackingTrends';

const AnalyticsPage: React.FC = () => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  return (
    <Container maxW="container.xl" py={8}>
      <Heading mb={8}>Analytics & Insights</Heading>

      <Tabs variant="enclosed" colorScheme="blue">
        <TabList>
          <Tab>Daily Overview</Tab>
          <Tab>Trends & Correlations</Tab>
          <Tab>Mood Analysis</Tab>
          <Tab>Location Insights</Tab>
          <Tab>Tag Analysis</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <Box
              bg={bgColor}
              borderRadius="lg"
              border="1px"
              borderColor={borderColor}
              p={6}
            >
              <Text fontSize="xl" fontWeight="medium" mb={6}>
                Daily Tracking Overview
              </Text>
              <DailyTrackingCalendar />
            </Box>
          </TabPanel>

          <TabPanel>
            <Box
              bg={bgColor}
              borderRadius="lg"
              border="1px"
              borderColor={borderColor}
              p={6}
            >
              <Text fontSize="xl" fontWeight="medium" mb={6}>
                Trends & Correlations
              </Text>
              <TrackingTrends />
            </Box>
          </TabPanel>

          <TabPanel>
            <Box
              bg={bgColor}
              borderRadius="lg"
              border="1px"
              borderColor={borderColor}
              p={6}
            >
              <Text fontSize="xl" fontWeight="medium" mb={6}>
                Mood Analysis
              </Text>
              <MoodTrendsChart />
            </Box>
          </TabPanel>

          <TabPanel>
            <Box
              bg={bgColor}
              borderRadius="lg"
              border="1px"
              borderColor={borderColor}
              p={6}
            >
              <Text fontSize="xl" fontWeight="medium" mb={6}>
                Location Insights
              </Text>
              <LocationStats />
            </Box>
          </TabPanel>

          <TabPanel>
            <Box
              bg={bgColor}
              borderRadius="lg"
              border="1px"
              borderColor={borderColor}
              p={6}
            >
              <Text fontSize="xl" fontWeight="medium" mb={6}>
                Tag Analysis
              </Text>
              <TagStats />
            </Box>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Container>
  );
};

export default AnalyticsPage; 